var TEST_STR = '__storetest__';
function testSupport() {
    try {
        sessionStorage.setItem(TEST_STR, TEST_STR);
        var ok = (sessionStorage.getItem(TEST_STR) === TEST_STR);
        sessionStorage.removeItem(TEST_STR);
        return ok;
    }
    catch (e) {
        return false;
    }
}
var SUPPORT = testSupport();
var EXPIRY_KEY = 'saveTime';
var DEFAULT_VALID_TIME = 8.64e6;
var LocalDb = (function () {
    function LocalDb(dbKey, validTime) {
        this.dbKey = dbKey;
        this.validTime = validTime;
    }
    LocalDb.prototype.get = function () {
        if (!SUPPORT) {
            return null;
        }
        try {
            var dataStr = sessionStorage.getItem(this.dbKey);
            if (!dataStr) {
                return null;
            }
            var res = JSON.parse(dataStr);
            if (!res || !res.data || !res[EXPIRY_KEY]) {
                return null;
            }
            var updateTime = parseInt(res[EXPIRY_KEY]);
            var nowTime = Date.now();
            var validTime = this.validTime || DEFAULT_VALID_TIME;
            if (nowTime - updateTime < validTime) {
                return res.data;
            }
            else {
                sessionStorage.removeItem(this.dbKey);
                return null;
            }
        }
        catch (e) {
            return null;
        }
    };
    LocalDb.prototype.save = function (obj) {
        var _a;
        if (SUPPORT) {
            try {
                sessionStorage.setItem(this.dbKey, JSON.stringify((_a = {},
                    _a[EXPIRY_KEY] = Date.now(),
                    _a.data = obj,
                    _a)));
            }
            catch (e) {
            }
        }
    };
    LocalDb.prototype.remove = function () {
        if (SUPPORT) {
            sessionStorage.removeItem(this.dbKey);
        }
    };
    LocalDb.prototype.markExpired = function () {
        if (!SUPPORT) {
            return false;
        }
        try {
            var dataStr = sessionStorage.getItem(this.dbKey);
            if (dataStr) {
                var res = JSON.parse(dataStr);
                res[EXPIRY_KEY] = -1;
                sessionStorage.setItem(this.dbKey, JSON.stringify(res));
                return true;
            }
            else {
                return false;
            }
        }
        catch (e) {
            return false;
        }
    };
    LocalDb.support = SUPPORT;
    return LocalDb;
}());
export default LocalDb;
